import { render, staticRenderFns } from "./facets-info-panel.vue?vue&type=template&id=9f520c60&"
import script from "./facets-info-panel.ts?vue&type=script&lang=ts&"
export * from "./facets-info-panel.ts?vue&type=script&lang=ts&"
import style0 from "./facets-info-panel.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports